// Drag scroll fix
(function () {
  const DRAG_THRESHOLD = 5;
  let startX = 0;
  let startY = 0;
  let isDragging = false;

  document.addEventListener('pointerdown', function (e) {
    startX = e.clientX;
    startY = e.clientY;
    isDragging = false;
  }, true);

  document.addEventListener('pointermove', function (e) {
    const dx = Math.abs(e.clientX - startX);
    const dy = Math.abs(e.clientY - startY);
    if (dx > DRAG_THRESHOLD || dy > DRAG_THRESHOLD) {
      isDragging = true;
    }
  }, true);

  document.addEventListener('click', function (e) {
    if (isDragging) {
      e.stopPropagation();
      e.preventDefault();
      isDragging = false;
    }
  }, true);
})();

// Hover resim değişimini engelle
document.addEventListener('DOMContentLoaded', function () {
  function disableImagePreview() {
    document.querySelectorAll('[data-product-id]').forEach(function (card) {
      card.removeAttribute('on:pointerenter');
      card.removeAttribute('on:pointerleave');
    });

    document.querySelectorAll('slideshow-component').forEach(function (el) {
      el.removeAttribute('on:pointerenter');
      el.removeAttribute('on:pointerleave');
      const slides = el.querySelectorAll('slideshow-slide, .slideshow-slide');
      slides.forEach(function (slide) {
        slide.removeAttribute('on:pointerenter');
        slide.removeAttribute('on:pointerleave');
      });
    });
  }

  disableImagePreview();

  // Dinamik yüklenen kartlar için de çalışsın
  const observer = new MutationObserver(disableImagePreview);
  observer.observe(document.body, { childList: true, subtree: true });
});